import React, {Fragment} from "react";
import {
    Button,
    Col,
    Collapse,
    Descriptions,
    Divider,
    Dropdown,
    List,
    Menu, notification,
    Popconfirm,
    Row,
    Space,
    Tag,
    Tooltip, Typography
} from "antd";
import PermissionHidden from "../../../../components/permissions/PermissionHidden";
import {
    AlertOutlined,
    CommentOutlined,
    CreditCardOutlined,
    DeleteOutlined, EditOutlined,
    EnvironmentOutlined, FieldTimeOutlined, FileOutlined,
    HomeOutlined,
    HourglassOutlined,
    InfoCircleOutlined,
    LinkOutlined,
    MailOutlined,
    MergeCellsOutlined, MinusCircleOutlined,
    NodeIndexOutlined,
    PhoneOutlined,
    PlusOutlined, ReloadOutlined,
    RollbackOutlined, ScheduleOutlined,
    SkinOutlined,
    TagOutlined, VerticalAlignBottomOutlined
} from "@ant-design/icons";
import RestrictedHidden from "../../../../components/permissions/RestrictedHidden";
import {checkForfait, checkPermissions} from "../../../../components/permissions/functions";
import {APP_PREFIX_PATH, ASSET_BASE_URL} from "../../../../configs/AppConfig";
import ContactIcon from "../../../../components/util-components/ContactIcon";
import moment from "moment";
import IntlMessage from "../../../../components/util-components/IntlMessage";
import ApiService from "../../../../services/ApiService";

const {Text, Title} = Typography

export class FicheCategories extends React.Component {

    async onRemoveTag(tag) {
        if (!checkPermissions(["contact.edit"]) || !checkForfait(["CRM", "COM", "FULL"])) {
            notification.error({
                message: <IntlMessage id="access.error"/>
            })
            return false
        }

        var res = await ApiService.post("/contact/removetag/" + this.props.selected.id, {tag: tag})
        console.log(res)

        if (res.success) {
            notification.success({
                message: <IntlMessage id="success.delete"/>
            })

            await this.props.fiche.getData()
        } else {
            notification.success({
                message: <IntlMessage id="error.delete"/>
            })
        }
    }

    render() {
        const {selected, preview, fiche} = this.props

        if (!selected) {
            return null
        }

        if (selected.categories.length === 0) {
            return null
        }

        if (selected.categories.length === 1) {
            return (<Tag style={{marginTop: 20}} color={"red"}>{selected.categories[0]}</Tag>)
        }

        if (preview) {
            const max = 2
            const _categs = selected.categories.slice(0, max)
            const reste = selected.categories.length - _categs.length

            return (
                <Row style={{gap: 5, marginTop: 20}}>
                    {_categs.map((i, k) => {
                        return (
                            <Popconfirm
                                key={k}
                                title={"Êtes-vous sûrs de vouloir retirer ce contact de la catégorie " + i + " ?"}
                                onConfirm={() => this.onRemoveTag(i)}
                                okText="Oui"
                                cancelText="Non"
                                okType={"danger"}
                            >
                                <Tag style={{cursor: "pointer"}} key={k} color={"red"}>{i}</Tag>
                            </Popconfirm>
                        )
                    })}

                    {reste > 0 && (
                        <Tag color={"red"}>+{reste}</Tag>
                    )}
                </Row>
            )
        }

        return (
            <Col>
                <Col style={{display: "flex", justifyContent: "flex-end", marginBottom: 30}}>
                    <Button type="primary" icon={<PlusOutlined/>}
                            onClick={() => fiche.modalAddTag.show([selected.id], selected.categories)}>Ajouter un
                        categorie</Button>
                </Col>
                <Row style={{gap: 5, marginTop: 20}}>
                    {selected.categories.map((i, k) => {
                        return (
                            <Popconfirm
                                key={k}
                                title={"Êtes-vous sûrs de vouloir retirer ce contact de la catégorie " + i + " ?"}
                                onConfirm={() => this.onRemoveTag(i)}
                                okText="Oui"
                                cancelText="Non"
                                okType={"danger"}
                            >
                                <Tag style={{cursor: "pointer"}} key={k} color={"red"}>{i}</Tag>
                            </Popconfirm>
                        )
                    })}
                </Row>
            </Col>
        )
    }
}
